import {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Routes } from "utils";

interface NavigationContextType {
  previousLocation: string | null;
  goBack: () => void;
  goHome: () => void;
}

const NavigationContext = createContext<NavigationContextType | undefined>(
  undefined
);

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error("useNavigation must be used within a NavigationProvider");
  }
  return context;
};

export const NavigationProvider = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [previousLocation, serPreviousLocation] = useState<string | null>(null);

  useEffect(() => {
    const storedLocation = sessionStorage.getItem("previousLocation");
    if (storedLocation) serPreviousLocation(storedLocation);

    return () => {
      sessionStorage.setItem("previousLocation", location.pathname);
    };
  }, [location.pathname]);

  const goHome = () => navigate(Routes.home); // Default fallback if no previous page is tracked

  const goBack = () => {
    if (previousLocation) {
      navigate(previousLocation);
    } else {
      goHome();
    }
  };

  return (
    <NavigationContext.Provider value={{ previousLocation, goBack, goHome }}>
      {children}
    </NavigationContext.Provider>
  );
};
